export const StyleFilters = {
    SET_STYLE: 'IN_MEMORY.STYLE.SET',
};

export const setStyle = style => ({
    type: StyleFilters.SET_STYLE,
    style
});